import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';
import store, { history } from './store';
import firebase from 'firebase';

import App from './App';
import LogIn from './components/LogIn';
import SignUp from './components/SignUp';
import UserSettings from './components/UserSettings';
import AddressList from './components/AddressList';
import LabelList from './components/LabelList';
import NewContact from './components/NewContact';

import './index.css';

const firebaseConfig = {
  apiKey: "AIzaSyBiVS2jJtUg8L5zq8kymLCa25_lcp-V9h8",
  authDomain: "update-my-address-book.firebaseapp.com",
  databaseURL: "https://update-my-address-book.firebaseio.com",
  storageBucket: "update-my-address-book.appspot.com",
  messagingSenderId: "400174057547"
};

firebase.initializeApp(firebaseConfig);


let isAuthenticated = false;
let prevRoute = location.pathname;

// look into better ways to do this
firebase.auth().onAuthStateChanged((user) => {
	isAuthenticated = user !== null;
	store.dispatch({type:'AUTHENTICATION_CHANGED',user});
	if (isAuthenticated) {
		console.log('moving to '+ prevRoute==='/login' ? '/' : prevRoute);

		history.push(prevRoute==='/login' ? '/' : prevRoute);
	} else {
		if (!(location.pathname.startsWith('/new/') || location.pathname.startsWith('/%F0%9F%93%9D/') || location.pathname.startsWith('/📝/'))) {
			console.log('prev route: '+prevRoute);
			// prevRoute = location.pathname;
			history.push('/login');
		}
	}
});

function verifyAuthentication() {
		prevRoute = location.pathname;
	if (!isAuthenticated) {
		history.push('/login');
	}
}

const router = (
	<Provider store={store}>
	  <Router history={history}>
	  	<Route path="/" component={App}>
	  		<IndexRoute component={AddressList} onEnter={verifyAuthentication}></IndexRoute>
	  	  <Route path="/login" component={LogIn}></Route>
	  	  <Route path="/signup" component={SignUp}></Route>
	  	  <Route path="/new/:requestorID" component={NewContact}></Route>
	  	  <Route path="/%F0%9F%93%9D/:requestorID" component={NewContact}></Route>
	  	  <Route path="/📝/:requestorID" component={NewContact}></Route>
	  	  <Route path="/usersettings" component={UserSettings} onEnter={verifyAuthentication}></Route>
	  	  <Route path="/labels" component={LabelList} onEnter={verifyAuthentication}></Route>
			</Route>
	  </Router>
	</Provider>
);

ReactDOM.render(
  router,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js